import { Component } from '@angular/core';

@Component({
  selector: 'app-supplementaryequipment-admin',
  templateUrl: './supplementaryequipment-admin.component.html',
  styleUrls: ['./supplementaryequipment-admin.component.scss']
})
export class SupplementaryequipmentAdminComponent {

}
